module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footerCon"
  }, [_vm._t("cleaner"), _vm._v(" "), _vm._t("footer")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92892830"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-functional-calendar/src/components/Footer.vue
// module id = 2517
// module chunks = 1